import { HttpClient } from '@connect-x-app/hybrid-data-access';
import { Role } from '@connect-x-app/shared-domain-models';
import { API_FACTORY } from '@connect-x-app/shared-utils';

export const updateRole = (values: Role): Promise<Role> =>
  HttpClient.patch(API_FACTORY.v3(`admin/roles/${values.id}`), {
    displayName: values.displayName,
    isTaggable: values.isTaggable,
    permissions: values.permissions,
    quickReplies: values.quickReplies,
  });

export const getRole = (roleId: string): Promise<Role> => HttpClient.get<Role>(API_FACTORY.v3(`admin/roles/${roleId}`));

export const getRoles = (): Promise<Role[]> => HttpClient.get<Role[]>(API_FACTORY.v3('admin/roles'));
